import { CancelButton } from "src/pages/OfferPage/TableSvgOrganizer/RowTools/CancelButton";
import { ConfirmButton } from "src/pages/OfferPage/TableSvgOrganizer/RowTools/ConfirmButton";
import { ts } from 'src/utils/translate';
import { DeleteButton } from 'src/pages/OfferPage/TableSvgOrganizer/RowTools/DeleteButton';
import { ModifyButton } from 'src/pages/OfferPage/TableSvgOrganizer/RowTools/ModifyButton';

export const RowTools = (props: any) => {
  const {
    cancelCustomRow,
    confirmCustomRow,
    deleteCustomRow,
    modifyCustomRow,
    table,
    row,
    currency,
    modifyRow,
    setModifyRow,
    modifyMode,
    setModifyMode,
    minusRow = false,
  } = props;

  return (
    <div
        className={`rowTools lightshadow ${
        modifyMode || minusRow ? "isMod" : ""
      }`}
    >
      {
        minusRow ? (
            <>
              <CancelButton
                title={ts("plt_cancel", "Cancel")}
                cancelCustomRow={cancelCustomRow}
                modifyRow={modifyRow}
                setModifyRow={setModifyRow}
                modifyMode={modifyMode}
                setModifyMode={setModifyMode}
              />
              <ConfirmButton
                title={ts("plt_confirm", "Confirm")}
                confirmCustomRow={confirmCustomRow}
              />
            </>
        ) : (
            <>
              <DeleteButton
                title={ts("q_delete_row", "Delete row")}
                deleteCustomRow={deleteCustomRow}
                table={table}
                row={row}
              />
              <ModifyButton
                title={ts("q_edit_row", "Edit row")}
                modifyCustomRow={modifyCustomRow}
                table={table}
                row={row}
                currency={currency}
              />
            </>
        )
      }
    </div>
  );
};
